export const appIcons = [
  "icon-01",
  "icon-02",
  "icon-03",
  "icon-04",
  "icon-05",
  "icon-06",
  "icon-07",
  "icon-08",
  "icon-09",
  "icon-10",
  "icon-11",
  "icon-12",
  "icon-13",
  "icon-14",
  "icon-15",
  "icon-16",
  "icon-17",
  "icon-18",
  "icon-19",
  "icon-20",
  "icon-21",
  "icon-22",
  "icon-23",
  "icon-24",
  "icon-25",
  "icon-26",
  "icon-27",
  "icon-28",
  "icon-29",
  "icon-30",
  "icon-31",
  "icon-32",
  "icon-33",
  "icon-34",
  "icon-35",
  "icon-36",
  "icon-37",
  "icon-38",
  "icon-39",
  "icon-40"
]
export const appColors = ["#1989FA", "#9A59FF", "#FD6565", "#40D492", "#FDA23F"]

export const appColumns = [
  {
    label: "应用名称",
    value: "name"
  },
  {
    label: "创建人",
    value: "creator.name",
    width: 200
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const appTableCmds = [
  {
    title: "导入",
    command: "import"
  },
  {
    title: "批量导出",
    command: "batchExport"
  }
]

export const appTemplateColumns = [
  {
    label: "应用模板名称",
    value: "name",
    width: 300
  },
  {
    label: "状态",
    value: "templateInfo.status",
    width: 150
  },
  {
    label: "当前版本号",
    value: "templateInfo.version",
    width: 150
  },
  {
    label: "已发布版本号",
    value: "templateInfo.remoteVersion",
    width: 150
  },
  {
    label: "使用范围",
    value: "templateInfo.range",
    width: 180
  },
  {
    label: "应用权限",
    value: "templateInfo.priMode",
    width: 150
  },
  {
    label: "最后修改人",
    value: "templateInfo.updateUser.name",
    width: 180
  },
  {
    label: "最后修改时间",
    value: "templateInfo.updateAt",
    width: 180
  },
  {
    label: "发布人",
    value: "creator.name",
    width: 180
  },
  {
    label: "发布时间",
    value: "createAt",
    width: 180
  }
]

export const templateHistoryColumns = [
  {
    label: "版本号",
    value: "version"
  },
  {
    label: "状态",
    value: "published",
    width: "70px"
  },
  {
    label: "更新内容",
    value: "desc"
  },
  {
    label: "创始人",
    value: "creator.name"
  },
  {
    label: "创建时间",
    value: "createAt",
    width: "140px"
  }
]

export const templateTypes = [
  { label: "项目研发", value: "项目研发" },
  { label: "采购管理", value: "采购管理" },
  { label: "生产制造", value: "生产制造" },
  { label: "客户销售", value: "客户销售" },
  { label: "物流运输", value: "物流运输" },
  { label: "售后服务", value: "售后服务" },
  { label: "财务管理", value: "财务管理" },
  { label: "行政人事", value: "行政人事" },
  { label: "其他", value: "其他" }
]

export const allTemplateTypes = [
  "企业模板",
  "互联模板",
  "项目研发",
  "采购管理",
  "生产制造",
  "客户销售",
  "物流运输",
  "售后服务",
  "财务管理",
  "行政人事",
  "其他"
]
